export const GET_EMPLOYEE_CAREER_PATH_REQUEST = 'GET_EMPLOYEE_CAREER_PATH_REQUEST';
export const GET_EMPLOYEE_CAREER_PATH_SUCCESS = 'GET_EMPLOYEE_CAREER_PATH_SUCCESS';
export const GET_EMPLOYEE_CAREER_PATH_FAIL    = 'GET_EMPLOYEE_CAREER_PATH_FAIL';

export const GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST = 'GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST';
export const GET_ALL_EMPLOYEE_CAREER_PATHS_SUCCESS = 'GET_ALL_EMPLOYEE_CAREER_PATHS_SUCCESS';
export const GET_ALL_EMPLOYEE_CAREER_PATHS_FAIL    = 'GET_ALL_EMPLOYEE_CAREER_PATHS_FAIL';

export const GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST = 'GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST';
export const GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_SUCCESS';
export const GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_FAIL    = 'GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_FAIL';

export const ASSIGN_CAREER_PATH_REQUEST = 'ASSIGN_CAREER_PATH_REQUEST';
export const ASSIGN_CAREER_PATH_SUCCESS = 'ASSIGN_CAREER_PATH_SUCCESS';
export const ASSIGN_CAREER_PATH_FAIL    = 'ASSIGN_CAREER_PATH_FAIL';

export const UPDATE_EMPLOYEE_CAREER_PATH_REQUEST = 'UPDATE_EMPLOYEE_CAREER_PATH_REQUEST';
export const UPDATE_EMPLOYEE_CAREER_PATH_SUCCESS = 'UPDATE_EMPLOYEE_CAREER_PATH_SUCCESS';
export const UPDATE_EMPLOYEE_CAREER_PATH_FAIL    = 'UPDATE_EMPLOYEE_CAREER_PATH_FAIL';

export const UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST = 'UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST';
export const UPDATE_EMPLOYEE_CAREER_PATH_STATUS_SUCCESS = 'UPDATE_EMPLOYEE_CAREER_PATH_STATUS_SUCCESS';
export const UPDATE_EMPLOYEE_CAREER_PATH_STATUS_FAIL    = 'UPDATE_EMPLOYEE_CAREER_PATH_STATUS_FAIL';

export const DELETE_EMPLOYEE_CAREER_PATH_REQUEST = 'DELETE_EMPLOYEE_CAREER_PATH_REQUEST';
export const DELETE_EMPLOYEE_CAREER_PATH_SUCCESS = 'DELETE_EMPLOYEE_CAREER_PATH_SUCCESS';
export const DELETE_EMPLOYEE_CAREER_PATH_FAIL    = 'DELETE_EMPLOYEE_CAREER_PATH_FAIL';

export const SET_EMPLOYEE_CAREER_PATH_LOADING = 'SET_EMPLOYEE_CAREER_PATH_LOADING';

// ── Action Creators ───────────────────────────────────────
export const getEmployeeCareerPathRequest = (id) => ({
    type: GET_EMPLOYEE_CAREER_PATH_REQUEST,
    payload: { id }
});
export const getEmployeeCareerPathSuccess = (data) => ({
    type: GET_EMPLOYEE_CAREER_PATH_SUCCESS,
    payload: data
});
export const getEmployeeCareerPathFail = (error) => ({
    type: GET_EMPLOYEE_CAREER_PATH_FAIL,
    error
});

export const getAllEmployeeCareerPathsRequest = () => ({
    type: GET_ALL_EMPLOYEE_CAREER_PATHS_REQUEST
});
export const getAllEmployeeCareerPathsSuccess = (data) => ({
    type: GET_ALL_EMPLOYEE_CAREER_PATHS_SUCCESS,
    payload: data
});
export const getAllEmployeeCareerPathsFail = (error) => ({
    type: GET_ALL_EMPLOYEE_CAREER_PATHS_FAIL,
    error
});

export const getEmployeeCareerPathsByEmployeeRequest = (employeeUserId) => ({
    type: GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_REQUEST,
    payload: { employeeUserId }
});
export const getEmployeeCareerPathsByEmployeeSuccess = (data) => ({
    type: GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_SUCCESS,
    payload: data
});
export const getEmployeeCareerPathsByEmployeeFail = (error) => ({
    type: GET_EMPLOYEE_CAREER_PATHS_BY_EMPLOYEE_FAIL,
    error
});

export const assignCareerPathRequest = (data) => ({
    type: ASSIGN_CAREER_PATH_REQUEST,
    payload: data
});
export const assignCareerPathSuccess = (data) => ({
    type: ASSIGN_CAREER_PATH_SUCCESS,
    payload: data
});
export const assignCareerPathFail = (error) => ({
    type: ASSIGN_CAREER_PATH_FAIL,
    error
});

export const updateEmployeeCareerPathRequest = (id, data) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_REQUEST,
    payload: { id, data }
});
export const updateEmployeeCareerPathSuccess = (data) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_SUCCESS,
    payload: data
});
export const updateEmployeeCareerPathFail = (error) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_FAIL,
    error
});

export const updateEmployeeCareerPathStatusRequest = (id, status) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_STATUS_REQUEST,
    payload: { id, status }
});
export const updateEmployeeCareerPathStatusSuccess = (id, status) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_STATUS_SUCCESS,
    payload: { id, status }
});
export const updateEmployeeCareerPathStatusFail = (error) => ({
    type: UPDATE_EMPLOYEE_CAREER_PATH_STATUS_FAIL,
    error
});

export const deleteEmployeeCareerPathRequest = (id) => ({
    type: DELETE_EMPLOYEE_CAREER_PATH_REQUEST,
    payload: { id }
});
export const deleteEmployeeCareerPathSuccess = (id) => ({
    type: DELETE_EMPLOYEE_CAREER_PATH_SUCCESS,
    payload: { id }
});
export const deleteEmployeeCareerPathFail = (error) => ({
    type: DELETE_EMPLOYEE_CAREER_PATH_FAIL,
    error
});

export const setEmployeeCareerPathLoading = (loading) => ({
    type: SET_EMPLOYEE_CAREER_PATH_LOADING,
    payload: loading
});